import React from "react";
import { COLORS } from "../myDashboardConstants";

export function MiniWinGauge({
  data, 
  label = "Win Ratio",
  size = "sm",
}) {
  const numericValue = typeof data === "string" ? parseFloat(data) : 0;
  const safeValue = isNaN(numericValue) ? 0 : numericValue;
  const angle = -90 + (safeValue / 100) * 180; 
  // Dynamic color based on value
  const zoneColor =
    safeValue < 40 ? COLORS.danger : safeValue < 70 ? COLORS.warning : COLORS.success; 
  const isLg = size === "lg";
  const gaugeMaxWidth = isLg ? 240 : 108;
  const gaugeHeight = isLg ? 135 : 60;
  const wrapperClass = isLg
    ? "sd-mini-gauge sd-mini-gauge-lg"
    : "sd-kpi sd-kpi-compact sd-mini-gauge";
  return (
    <div className={wrapperClass}>
      <div
        style={{
          width: "100%",
          maxWidth: gaugeMaxWidth,
          height: gaugeHeight,
          position: "relative",
          margin: "0 auto",
        }}
      >
        <svg
          viewBox="0 0 200 120"
          className="sd-gauge-svg"
          preserveAspectRatio="xMidYMax meet"
        >
          <defs>
            <linearGradient id="miniGaugeGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor={COLORS.danger} />
              <stop offset="50%" stopColor={COLORS.warning} />
              <stop offset="100%" stopColor={COLORS.success} />
            </linearGradient>
          </defs>
          <path
            d="M 16,108 A 84,84 0 0 1 184,108"
            fill="none"
            stroke="#EEF1F6"
            strokeWidth="18"
            strokeLinecap="round"
          />
          <path
            d="M 16,108 A 84,84 0 0 1 184,108"
            fill="none"
            stroke="url(#miniGaugeGrad)"
            strokeWidth="18"
            strokeLinecap="round"
          />
          <g
            style={{
              transform: `rotate(${angle}deg)`,
              transformOrigin: "100px 108px",
              transition: "transform 0.6s cubic-bezier(.34,1.4,.64,1)",
            }}
          >
            <line
              x1="100"
              y1="108"
              x2="100"
              y2="48"
              stroke={COLORS.heading}
              strokeWidth="4"
              strokeLinecap="round"
            />
          </g>
          <circle
            cx="100"
            cy="108"
            r="7"
            fill="#fff"
            stroke={COLORS.heading}
            strokeWidth="3"
          />
        </svg>
      </div>
      <div
        style={{
          fontSize: isLg ? 34 : 16,
          fontWeight: 800,
          color: zoneColor,
          textAlign: "center",
          marginTop: isLg ? 6 : 2,
        }}
      >
        {/* Actual value string dikhayega (e.g. "8.57%") */}
        {data}
      </div>
      <div
        className="sd-kpi-label"
        style={{ textAlign: "center", fontSize: isLg ? 14 : undefined }}
      >
        {label}
      </div>
    </div>
  );
}
